import React, { BaseSyntheticEvent, useRef } from "react";
import "../../styles/legacy-css/ItemSubmission.css";
import TagsInput from "./TagsInput";
import { useState, useEffect } from "react";
import { formatImageWithLarge } from "../../utils/saveImageToS3";
import { PlusSquare } from "react-bootstrap-icons";
import {
  useAccountContext,
  cognitoUserAttributes,
} from "../../contexts/Account";
import { useScrollLock } from "../../hooks";
import { v4 as uuidv4 } from "uuid";
import {
  useUserDataContext,
  cFRow,
  itemDataFromDynamo,
} from "../../contexts/UserDataContext";
import defaultImg from "../../assets/images/No_Image_Icon.jpg";
import { calculateParentPath } from "../../utils/CalculateItems";
import { ImageDiv, ImageLink } from "../../styles/components/Links.styled";
import {
  Button,
  ItemSubmissionImageDelete,
  StyledIS_CardButton,
  StyledIS_CardButton_Bulk,
} from "../../styles/components/Buttons.styled";
import {
  StyledItemSubmissionCFContainer,
  StyledItemSubmissionCFData,
  StyledItemSubmissionCFDeleteBtnContainer,
  StyledItemSubmissionCFItem,
  StyledItemSubmissionForm,
  StyledItemSubmissionFormImgInput,
  StyledItemSubmissionFormImgLabel,
  StyledItemSubmissionFormInput,
  StyledItemSubmissionFormLabel,
  StyledItemSubmissionFormSpan,
  StyledItemSubmissionFormTextArea,
  StyledItemSubmissionImageDiv,
  StyledItemSubmissionImg,
  StyledIS_Wrapper,
  StyledItemSubmissionPopupMessage,
  StyledIS_ButtonContainer,
  StyledISTrashButton,
  ItemSubmissionInUseInd,
  StyledItemSubmissionCenteredDiv,
  StyledResponsiveSpan,
  StyledLocWithBulk,
} from "../../pages/MyItems/ItemSubmission.styled";
import { Trash, QuestionCircle } from "react-bootstrap-icons";
import {
  StyledInnerPopup,
  StyledOuterPopup,
} from "../../styles/components/Popup.styled";
import heic2any from "heic2any";
import { GeoAlt, BagCheck, Bag } from "react-bootstrap-icons";
import ImageModal from "../common/ImageModal";

interface Props {
  httpMethod: string;
  itemId: string;
}

export function ItemFormUpgradePopup(props: Props) {
  const { setupgradedItemFormOpen } = useUserDataContext();

  // Lock scrolling when modal is open
  useScrollLock(true);

  function closeItemForm() {
    setupgradedItemFormOpen(false);
  }
  return (
    <StyledOuterPopup>
      <StyledInnerPopup>
        <ItemFormUpgrade httpMethod={props.httpMethod} itemId={props.itemId} />
      </StyledInnerPopup>
    </StyledOuterPopup>
  );
}

export function ItemFormUpgrade(props: Props) {
  //Delete this
  const [msg, setmsg] = useState("None"); // File uploaded from user
  //#region CONSTS
  const [file, setFile] = useState<File>(); // File uploaded from user
  const [fileUrlMainImage, setFileUrlMainImage] = useState<string>(); //URL of compressed main image (data URL for S3 upload)
  const [fileUrlLargeImage, setFileUrlLargeImage] = useState<string>(); //URL of large image (data URL for S3 upload)
  const [filePreviewUrl, setFilePreviewUrl] = useState<string>(); //Blob URL for preview display (CSP-friendly)
  const [cFRows, setCFRows] = useState<cFRow[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [item, setItem] = useState<itemDataFromDynamo | {}>({});
  const [error, setError] = useState<string[] | null>(null);
  const [timeoutId, setTimeoutId] = useState<undefined | NodeJS.Timeout>(
    undefined
  );
  const [bulkAdd, setBulkAdd] = useState(false);
  const bulkAddLabel = bulkAdd ? "Back" : "Bulk Add";
  const { loggedInUserCognitoIdToken, userCognitoAttrubutes } =
    useAccountContext();
  const {
    setNewItemPopupOpen,
    curItemData,
    setCurItemData,
    curParent,
    newItemPopupOpen,
    itemMap,
    setItemMap,
    setParentMap,
    parentMap,
    setCurParent,
    parentToBe,
    setEditItemPopupOpen,
    setupgradedItemFormOpen,
    setItemToDelete,
    recalculateCurrentArray,
    searchMap,
    setSearchMap,
    popupMessage,
    setPopupMessage,
    setIsLoading,
    isLoading,
    SaveItem,
    setParentToBe,
    setItemToMoveOrUse,
  } = useUserDataContext();
  //#endregion CONSTS

  async function handleSave(e: any) {
    e.preventDefault();
    var close = e.nativeEvent.submitter.id == "SaveClose";

    //#region VALIDATION
    //Validate data and return if error is caught
    //Exit function if error exists
    var error: string[] = validateSaveData(file!, e);
    if (error.length > 0) {
      setError(error);
      return;
    }
    setError(null); //set to null since no validation errors exist
    //#endregion VALIDATION

    //#region SET ITEM VALUE
    var uuid = uuidv4(); //Used as new itemId
    //set the parentId to the parent of the item being inserted. If already set to master then leave at master
    var parentid =
      parentToBe == "MASTER" ? "MASTER" : itemMap[parentToBe].ItemId;

    var itemData: itemDataFromDynamo = {
      ItemId: curItemData.hasOwnProperty("ItemId")
        ? (curItemData as itemDataFromDynamo).ItemId
        : uuid,
      Name: e.target.name == undefined ? undefined : e.target.name.value,
      Desc: e.target.desc == undefined ? undefined : e.target.desc.value,
      Quantity: e.target.quantity == undefined ? "" : e.target.quantity.value,
      Tags: tags == null ? [] : tags,
      CustomFields: cFRows == null ? [] : cFRows,
      Image: (curItemData as itemDataFromDynamo).Image,
      ParentId: parentid,
      InUse: (curItemData as itemDataFromDynamo).InUse,
      InUseNote: (curItemData as itemDataFromDynamo).InUseNote,
    };
    if (file != undefined) {
      itemData = {
        ...itemData,
        Image: process.env.REACT_APP_AWS_PATH! + "{CLIENTID}" + "/" + uuid,
      };
    }

    //Moved To Then Statement of SaveItem Call
    // setItem(itemData);
    // e.target.name.value = "";
    // e.target.desc.value = "";
    // e.target.quantity.value = "";
    // setTags([]);
    // setCFRows([]);
    // setFile(undefined);

    //#endregion SET ITEM VALUE

    //#region UPDATE DATA
    setIsLoading("Saving...");
    //let startTime: number = Date.now();
    //This call will add the data to dynamoDB and add the files to S3
    await SaveItem(
      itemData,
      uuid,
      close,
      fileUrlMainImage!,
      (userCognitoAttrubutes as cognitoUserAttributes).sub!,
      true,
      fileUrlLargeImage
    )
      .then((res) => {
        setItem(itemData);
        if (e.target.name != undefined) e.target.name.value = "";
        if (e.target.desc != undefined) e.target.desc.value = "";
        if (e.target.quantity != undefined) e.target.quantity.value = "";
        setTags([]);
        setCFRows([]);
        setFile(undefined);
        if (e.nativeEvent.submitter.id == "SaveEnter") {
          setCurParent(itemData.ItemId);
          setParentToBe(itemData.ItemId);
        }
      })
      .catch((error) => {
        if (error != null) {
          if (error === 0) {
            alert(
              "Error saving data. This issue can be a result of lost internet connection. Please check your connection and try again."
            );
          } else {
            alert(
              "Error saving data. Please try again. If issue persists please contact Admin@WheresOur.com and let them know that the responce returned a status code = " +
                error +
                "."
            );
          }
        } else {
          alert(
            "Error saving data. Please try again. If issue persists please contact Admin@WheresOur.com"
          );
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    // setTimeout(() => {
    //   setIsLoading(false);
    // }, Math.max(0, 500 + startTime - Date.now()));
    //#endregion UPDATE DATA
  }

  //#region USE EFFECTS
  useEffect(() => {
    setTags((curItemData as itemDataFromDynamo).Tags);
    setCFRows((curItemData as itemDataFromDynamo).CustomFields);
  }, [item]);

  useEffect(() => {}, [cFRows]);

  useEffect(() => {
    const reader = new FileReader();
    if (!file) return;
    reader.readAsDataURL(file);

    //Process image once and get both formats
    reader.onload = function (ev) {
      const fetchData = async () => {
        const { blobUrl, dataUrl, largeDataUrl } = await formatImageWithLarge(
          ev,
          parseInt(process.env.REACT_APP_IMAGE_MAIN_MAX_WIDTH!),
          parseInt(process.env.REACT_APP_LARGE_IMAGE_MAX_WIDTH || '1200')
        );
        setFilePreviewUrl(blobUrl);
        setFileUrlMainImage(dataUrl);
        setFileUrlLargeImage(largeDataUrl);
      };
      fetchData();
    };
  }, [file]);

  useEffect(() => {
    setPopupMessage("");
  }, []);

  // Cleanup blob URL to prevent memory leaks
  useEffect(() => {
    return () => {
      if (filePreviewUrl && filePreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(filePreviewUrl);
      }
    };
  }, [filePreviewUrl]);

  //#endregion USE EFFECTS

  //#region FUNCTIONS
  function addCFRow() {
    if (cFRows == null || cFRows.length === 0) {
      setCFRows([{ id: 1, key: null, value: null }]);
    } else {
      setCFRows((c) => [
        ...c,
        { id: c[cFRows.length - 1].id + 1, key: null, value: null },
      ]);
    }
    setDoSetAutoFocus(true);
  }
  function deleteCFRow(id: number) {
    setCFRows(cFRows.filter((row) => row.id !== id));
    setDoSetAutoFocus(true);
  }
  function setCFKey(event: any) {
    var index = cFRows.findIndex((c) => c.id === parseInt(event.target.id));
    if (event.target.value === "") {
      cFRows[index].key = null;
      return;
    }
    cFRows[index].key = event.target.value;
  }
  function setCFValue(event: any) {
    var index = cFRows.findIndex((c) => c.id === parseInt(event.target.id));
    if (event.target.value === "") {
      cFRows[index].value = null;
      return;
    }
    cFRows[index].value = event.target.value;
  }
  async function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (
      event.currentTarget.files![0] != null &&
      (event.currentTarget.files![0].type.toLowerCase() == "image/heic" ||
        event.currentTarget.files![0].name.toLowerCase() == "image/heif")
    ) {
      const output = (await heic2any({
        blob: event.currentTarget.files![0],
        toType: "image/jpeg",
        quality: 1,
      })) as File;

      setFile(output);
    } else {
      setFile(event.currentTarget.files![0]);
    }
  }
  function deleteimage() {
    // Revoke blob URL to free memory
    if (filePreviewUrl && filePreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(filePreviewUrl);
    }

    setCurItemData({ ...curItemData!, Image: "" });
    setFile(undefined);
    setFilePreviewUrl(undefined);
    setFileUrlMainImage(undefined);
    setFileUrlLargeImage(undefined);
  }

  function validateSaveData(file: File, e: any) {
    var errorArray: string[] = [];
    //#region VALIDATION
    //Validate data - Split this out into other functions
    //Validation - Name or Image is Required
    if (file === undefined && e.target.name.value === "") {
      errorArray.push("Item requires a name or an image.");
    }

    //Validation - Custom field rows have keys and values
    let cFRowCount = 0;
    if (cFRows != null) {
      cFRows.forEach(function (row) {
        if (row.key === null || row.value === null) {
          errorArray.push(
            "Missing value for key and/or value on Custom Filed row " + row.id
          );
        }
      });
    }

    //Validation - quantity value is a number if one is entered
    if (
      e.target.quantity != undefined &&
      Number.isNaN(parseInt(e.target.quantity.value)) &&
      e.target.quantity.value !== ""
    ) {
      errorArray.push("Quantity must be a number.");
    }
    return errorArray;
  }

  //Moved Post and Put outside of function
  function handleSuccessfulHttpPost(itemData: itemDataFromDynamo) {
    //Update the item hashmap with the new item
    var itemHashMap: Record<string, itemDataFromDynamo> = {};
    for (const key in itemMap) {
      itemHashMap[key] = itemMap[key];
    }
    itemHashMap[itemData.ItemId] = itemData;

    var parentHashMap: Record<string, Set<string>> = {};
    for (const key in parentMap) {
      parentHashMap[key] = parentMap[key];
    }

    if (parentHashMap[itemData.ParentId!] == null) {
      parentHashMap[itemData.ParentId!] = new Set<string>();
    }
    var s = parentHashMap[itemData.ParentId!].add(itemData.ItemId!);

    //this is the issue
    parentHashMap[itemData.ParentId!] = parentHashMap[itemData.ParentId!].add(
      itemData.ItemId!
    );

    recalculateCurrentArray(parentHashMap, curParent, itemHashMap);
    setItemMap(itemHashMap);
    setParentMap(parentHashMap);
  }
  function handleSuccessfulHttpPut(itemData: itemDataFromDynamo) {
    //Update the item hashmap with the updated item data
    var itemHashMap: Record<string, itemDataFromDynamo> = {};
    for (const key in itemMap) {
      if (key == itemData.ItemId) {
        itemHashMap[key] = itemData;
      } else {
        itemHashMap[key] = itemMap[key];
      }
    }
    var parentHashMap: Record<string, Set<string>> = {};
    for (const key in parentMap) {
      parentHashMap[key] = parentMap[key];
    }
    if (parentHashMap[itemData.ParentId!] == null) {
      parentHashMap[itemData.ParentId!] = new Set<string>();
    }
    parentHashMap[itemData.ParentId!] = parentHashMap[itemData.ParentId!].add(
      itemData.ItemId!
    );
    recalculateCurrentArray(parentHashMap, curParent, itemHashMap);
    setItemMap(itemHashMap);
    setParentMap(parentHashMap);
  }

  //#endregion FUNCTIONS

  const imgRef = useRef<HTMLDivElement>(document.createElement("div"));
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setX(e.x);
      setY(e.y);
    };
    imgRef.current.addEventListener("mousemove", handleMouseMove);
    return () => {
      if (imgRef.current != null) {
        imgRef.current.removeEventListener("mousemove", handleMouseMove);
      }
    };
  }, []);

  var parentDisplay = curItemData.hasOwnProperty("ParentId")
    ? (curItemData as itemDataFromDynamo).ParentId
    : curParent;

  const tagsMessage =
    "Tags are searchable terms used to find items using the search bar at the top of the main page. " +
    "To add a tag, type the term you want to use, such as 'Sweater' " +
    " and press enter. To delete a tag, click the trash icon next to the tag you wish to delete";
  const imageMessage = "I am the image message";
  const cFMessage =
    "Custom Fields are available to provide additional data on about an item. The fields are not currently searchable but can " +
    "provide an organized way to keep data such as a warranty or expiration date. To add a custom field, click the plus (+) icon and fill out the " +
    "custom field key and value. Both are required in order to submit the data.";
  const lPMessage =
    "The Location Path shows the location where the item you are viewing is located. In addition, hovering over (clicking on mobile) a location in the path will display the picture of the location.";

  //const timeoutId = useRef(undefined)
  //let timeoutId: undefined | ReturnType<typeof setTimeout> = undefined

  function DescriptionPopup(
    e: BaseSyntheticEvent,
    Message: string,
    timeout: number
  ) {
    e.preventDefault();
    clearTimeout(timeoutId);
    setPopupMessage(Message);
    setTimeoutId(
      setTimeout(() => {
        setPopupMessage("");
      }, timeout * 1000)
    );
  }

  const cfInputRef = useRef<HTMLInputElement>(null);
  const [doSetAutoFocus, setDoSetAutoFocus] = useState(false);

  useEffect(() => {
    if (doSetAutoFocus) {
      if (cfInputRef.current !== null) {
        window.setTimeout(function () {
          document.getElementById(cfInputRef.current!.id)!.focus();
        }, 0);
      }
      setDoSetAutoFocus(false);
    }
  }, [doSetAutoFocus]);

  console.log(curItemData)

  const imageSrc =
  file && filePreviewUrl
    ? filePreviewUrl
    : (curItemData as itemDataFromDynamo).Image
      ? (curItemData as itemDataFromDynamo).Image + "_mainimg.jpeg"
      : "";

  return (
    <StyledIS_Wrapper>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <StyledItemSubmissionForm
        onSubmit={(e) => handleSave(e)}
        //Prevent having enter submit the form but allow enter to add newline in text areas
        onKeyDown={(e: BaseSyntheticEvent) => {
          if (e.type === "keydown") {
            if (e.target.type !== "textarea") {
              var ke: KeyboardEvent = e.nativeEvent as KeyboardEvent;
              if (ke.key === "Enter") {
                e.preventDefault();
              }
            }
          }
        }}
      >
        {popupMessage != "" && (
          <StyledItemSubmissionPopupMessage onClick={() => setPopupMessage("")}>
            {popupMessage} - Click this message to close
          </StyledItemSubmissionPopupMessage>
        )}
        <StyledItemSubmissionImageDiv>
          {(file ||
            (curItemData as itemDataFromDynamo).hasOwnProperty("Image")) && (
            <StyledItemSubmissionCenteredDiv>
              <ImageModal
                src={imageSrc}
                quantity={(curItemData as itemDataFromDynamo).Quantity}
              />
              {(file != undefined ||
                ((curItemData as itemDataFromDynamo).Image?.trim() != "" &&
                  (curItemData as itemDataFromDynamo).Image?.trim() !=
                    null)) && (
                <ItemSubmissionImageDelete type="button" onClick={deleteimage}>
                  Delete
                </ItemSubmissionImageDelete>
              )}
            </StyledItemSubmissionCenteredDiv>
          )}
          {(curItemData as itemDataFromDynamo).ItemId && (
            <ItemSubmissionInUseInd
              onClick={() =>
                setItemToMoveOrUse((curItemData as itemDataFromDynamo).ItemId)
              }
              title={
                (curItemData as itemDataFromDynamo).InUse &&
                (curItemData as itemDataFromDynamo).InUseNote
                  ? `In use: ${(curItemData as itemDataFromDynamo).InUseNote}`
                  : undefined
              }
            >
              {(curItemData as itemDataFromDynamo).InUse && <BagCheck />}
              {!(curItemData as itemDataFromDynamo).InUse && <Bag />}
            </ItemSubmissionInUseInd>
          )}
        </StyledItemSubmissionImageDiv>
        <StyledItemSubmissionFormLabel>
          <StyledLocWithBulk onClick={(e) => e.preventDefault()}>
            <span>
              Location Path{" "}
              <QuestionCircle
                onClick={(e) => DescriptionPopup(e, lPMessage, 10)}
              />
            </span>
            <StyledResponsiveSpan>
              <StyledIS_CardButton_Bulk
                onClick={(e) => {
                  setBulkAdd(!bulkAdd);
                }}
              >
                {bulkAddLabel}
              </StyledIS_CardButton_Bulk>
            </StyledResponsiveSpan>
          </StyledLocWithBulk>
          <span ref={imgRef}>
            {calculateParentPath(itemMap, parentDisplay, curItemData).map(
              (s, index) => (
                <span onClick={(e) => e.preventDefault()} key={index}>
                  {s != "MASTER" ? (
                    itemMap[s].Name != null && itemMap[s].Name?.trim() != "" ? (
                      <span>
                        /<ImageLink>{itemMap[s].Name}</ImageLink>
                        {x != 0 && (
                          <ImageDiv x={x} y={y}>
                            {itemMap[s].ParentId != null && (
                              <img
                                className="card-img"
                                src={
                                  itemMap[s].Image != null
                                    ? itemMap[s].Image + "_mainimg.jpeg"
                                    : defaultImg
                                }
                                onError={(o) => {
                                  var img = defaultImg;
                                  if (o.currentTarget.src != img) {
                                    o.currentTarget.src = img;
                                  }
                                }}
                              />
                            )}
                          </ImageDiv>
                        )}
                      </span>
                    ) : (
                      <span>
                        /<ImageLink>UNTITLED</ImageLink>
                        {x != 0 && (
                          <ImageDiv x={x} y={y}>
                            {itemMap[s].ParentId != null && (
                              <img
                                className="card-img"
                                src={
                                  itemMap[s].Image != null
                                    ? itemMap[s].Image + "_mainimg.jpeg"
                                    : defaultImg
                                }
                                onError={(o) => {
                                  var img = defaultImg;
                                  if (o.currentTarget.src != img) {
                                    o.currentTarget.src = img;
                                  }
                                }}
                              />
                            )}
                          </ImageDiv>
                        )}
                      </span>
                    )
                  ) : (
                    <span>
                      <ImageLink>MASTER</ImageLink>
                    </span>
                  )}
                </span>
              )
            )}
          </span>
        </StyledItemSubmissionFormLabel>
        <StyledItemSubmissionFormLabel>
          <StyledItemSubmissionFormSpan>Name</StyledItemSubmissionFormSpan>
          <StyledItemSubmissionFormInput
            data-lpignore="true"
            type="text"
            name="name"
            placeholder="Item Name"
            defaultValue={(curItemData as itemDataFromDynamo).Name}
            maxLength={50}
          />
        </StyledItemSubmissionFormLabel>
        {!bulkAdd && (
          <StyledItemSubmissionFormLabel>
            <StyledItemSubmissionFormSpan>
              Description
            </StyledItemSubmissionFormSpan>
            <StyledItemSubmissionFormTextArea
              data-lpignore="true"
              name="desc"
              placeholder="Item Description"
              defaultValue={(curItemData as itemDataFromDynamo).Desc}
              maxLength={500}
            />
          </StyledItemSubmissionFormLabel>
        )}
        {!bulkAdd && (
          <StyledItemSubmissionFormLabel>
            <StyledItemSubmissionFormSpan>
              Quantity
            </StyledItemSubmissionFormSpan>
            <StyledItemSubmissionFormInput
              data-lpignore="true"
              type="text"
              name="quantity"
              placeholder="Enter Quantity"
              defaultValue={(curItemData as itemDataFromDynamo).Quantity}
              maxLength={10}
            />
          </StyledItemSubmissionFormLabel>
        )}
        {!(file || (curItemData as itemDataFromDynamo).Image) && (
          <StyledItemSubmissionFormLabel>
            <StyledItemSubmissionFormSpan>Image</StyledItemSubmissionFormSpan>
            <StyledItemSubmissionFormImgLabel htmlFor="input-file">
              Select a file
            </StyledItemSubmissionFormImgLabel>
            <StyledItemSubmissionFormImgInput
              type="file"
              accept="image/*"
              id="input-file"
              onChange={handleFileChange}
            />
          </StyledItemSubmissionFormLabel>
        )}
        {!bulkAdd && (
          <StyledItemSubmissionFormLabel>
            <StyledItemSubmissionFormSpan>
              Tags{" "}
              <QuestionCircle
                onClick={(e) => DescriptionPopup(e, tagsMessage, 15)}
              />
            </StyledItemSubmissionFormSpan>
            <TagsInput tags={tags} setTags={setTags} />
          </StyledItemSubmissionFormLabel>
        )}
        {!bulkAdd && (
          <StyledItemSubmissionFormLabel>
            <StyledItemSubmissionFormSpan>
              Custom Fields{" "}
              <QuestionCircle
                onClick={(e) => DescriptionPopup(e, cFMessage, 20)}
              />
            </StyledItemSubmissionFormSpan>
            <StyledItemSubmissionCFContainer>
              {cFRows != null &&
                cFRows.length > 0 &&
                cFRows.map((cFRow, index) => (
                  <StyledItemSubmissionCFItem key={index}>
                    <StyledItemSubmissionCFData>
                      <StyledItemSubmissionFormInput
                        data-lpignore="true"
                        type="text"
                        name="CustomFields"
                        placeholder={"Enter Custom Field Key"}
                        id={cFRow.id.toString() + "CFROW"}
                        key={cFRow.id.toString() + "key"}
                        defaultValue={cFRow.key == null ? "" : cFRow.key}
                        onChange={setCFKey}
                        ref={
                          index === cFRows.length - 1 ? cfInputRef : undefined
                        }
                        maxLength={50}
                      />
                      <StyledItemSubmissionFormTextArea
                        data-lpignore="true"
                        name="CustomFields"
                        placeholder="Enter Custom Field Value"
                        id={cFRow.id.toString()}
                        key={cFRow.id.toString() + "value"}
                        defaultValue={cFRow.value == null ? "" : cFRow.value}
                        onChange={setCFValue}
                        maxLength={250}
                      />
                    </StyledItemSubmissionCFData>
                    {cFRows.length > 0 && (
                      <StyledItemSubmissionCFDeleteBtnContainer>
                        <StyledISTrashButton
                          type="button"
                          onClick={() => deleteCFRow(cFRow.id)}
                        >
                          <Trash />
                        </StyledISTrashButton>
                      </StyledItemSubmissionCFDeleteBtnContainer>
                    )}
                  </StyledItemSubmissionCFItem>
                ))}
              <div>
                <PlusSquare onClick={addCFRow} />
              </div>
            </StyledItemSubmissionCFContainer>
          </StyledItemSubmissionFormLabel>
        )}
        {error != null &&
          error.length > 0 &&
          error.map((e, index) => (
            <div className="itemsubmission-errormessage" key={index}>
              {e}
            </div>
          ))}
        {!bulkAdd && (
          <StyledIS_ButtonContainer>
            <StyledIS_ButtonContainer>
              <StyledIS_CardButton type="submit" id="SaveNew">
                Save and Add New
              </StyledIS_CardButton>
              <StyledIS_CardButton type="submit" id="SaveClose">
                Save and close
              </StyledIS_CardButton>
            </StyledIS_ButtonContainer>
            <StyledIS_ButtonContainer>
              {!(curItemData as itemDataFromDynamo).ItemId && (
                <StyledIS_CardButton type="submit" id="SaveEnter">
                  Save and Enter
                </StyledIS_CardButton>
              )}
              <StyledIS_CardButton
                type="button"
                onClick={() => {
                  setupgradedItemFormOpen(false);
                }}
              >
                Cancel
              </StyledIS_CardButton>
              {(curItemData as itemDataFromDynamo).ItemId && (
                <StyledIS_CardButton
                  type="button"
                  onClick={() => {
                    setItemToDelete((curItemData as itemDataFromDynamo).ItemId);
                  }}
                >
                  Delete
                </StyledIS_CardButton>
              )}
            </StyledIS_ButtonContainer>
          </StyledIS_ButtonContainer>
        )}
        {bulkAdd && (
          <StyledIS_ButtonContainer>
            <StyledIS_ButtonContainer>
              <StyledIS_CardButton type="submit" id="SaveNew">
                Save and Add New
              </StyledIS_CardButton>
              <StyledIS_CardButton
                type="button"
                onClick={() => {
                  setupgradedItemFormOpen(false);
                }}
              >
                Return to Location
              </StyledIS_CardButton>
            </StyledIS_ButtonContainer>
          </StyledIS_ButtonContainer>
        )}
      </StyledItemSubmissionForm>
    </StyledIS_Wrapper>
  );
}
